import {
  Image,
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { urlStart } from "../../../utility/Index";
import { CommonButton } from "../../../common/CommonButton";
import { SwitchCommon } from "../../../common/SwitchCommon";
import RemainingCostModalComponent from "../../../Components/ongoing-common-components/RemainingCostModalComponent";
import CallOutModalComponent from "../../../Components/ongoing-common-components/CallOutModalComponent";

export default function RequiredAttendeesModal(props) {
  const { showModal = false, setShowModal, eventType, backTapped , details } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View style={styles.header}>
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_15,
                {
                  fontWeight: 800,
                },
              ]}
            >
              Your event has not reached the minimum required attendees to cover
              the costs. Please choose one of the following options to proceed:
            </Text>
            <TouchableOpacity onPress={onCloseClick} activeOpacity={0.5}>
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height: 28,
                  width: 28,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>
          <RemainingCostModalComponent styles={styles} details={details} />
          <CallOutModalComponent styles={styles} details={details} />
        </View>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "50%",
      backgroundColor: AppColors.appBlueColor_3A5175,
      paddingHorizontal: 30,
      //   margin: 30,
      alignSelf: "center",
      borderRadius: 12,
      paddingBottom: 30,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingBottom: 50,
      paddingHorizontal: 10,
      alignItems: "center",
      gap: 50,
      paddingTop: 20,
    },

    buttonStyle: {
      flex: 1,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderRadius: 12,
      justifyContent: "center",
      alignItems: "center",
    },
    buttonTextStyle: {
      fontSize: 16,
    },
    footerText: {
      flexDirection: "row",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      paddingHorizontal: 16,
      paddingVertical: 16,
      borderRadius: 10,
      marginBottom: 20,
      gap: 5,
      alignItems: "center",
    },
    tokenPrice: {
      //   paddingBottom: 5,
      color: AppColors.white,
      fontWeight: 700,
      fontSize: 24,
      paddingVertical: 10,
    },
    benefitsData: {
      //   flex: 1,
      paddingHorizontal: 10,
      marginVertical: 20,
    },
    optionBtnStyle: {
      paddingVertical: 0,
      paddingHorizontal: 10,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      height: 27,
      alignSelf: "center",
      borderRadius: 10,
      width: 90,
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    remainCostBtn: {
      paddingVertical: 0,
      paddingHorizontal: 10,
      backgroundColor: AppColors.black_121212,
      shadowOpacity: 0,
      height: 36,
      alignSelf: "center",
      borderRadius: 10,
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    buyTokenBtn: {
      paddingVertical: 0,
      paddingHorizontal: 10,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 30,
      alignSelf: "center",
      borderRadius: 10,
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    remainCost: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "60%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 25,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 25,
        paddingHorizontal: 10,
      },

      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "70%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 16,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
        paddingBottom: 30,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 25,
        paddingHorizontal: 10,
      },

      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "60%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 16,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 25,
        paddingHorizontal: 10,
        gap: 10,
      },

      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      remainCost: {
        flexDirection: "column",
        gap: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "90%",
        backgroundColor: AppColors.appBlueColor_3A5175,
        paddingHorizontal: 16,
        // margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 25,
        paddingHorizontal: 10,
        gap: 10,
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 16,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      remainCost: {
        flexDirection: "column",
        gap: 10,
      },
    },
  }
);
